<template>
  <div
    class="marker"
    :class="mode"
    :style="markerStyle"
  >
    <!-- Slot para íconos -->
    <slot />

    <!-- Efectos especiales según el modo -->
    <template v-if="mode === 'laser'">
      <div class="laser-line top" :style="lineStyle"></div>
      <div class="laser-line right" :style="lineStyle"></div>
      <div class="laser-line bottom" :style="lineStyle"></div>
      <div class="laser-line left" :style="lineStyle"></div>
    </template>

    <template v-if="mode === 'scanner'">
      <div class="scanner-line" :style="scannerStyle"></div>
    </template>
  </div>
</template>

<style scoped>
.marker {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* --- Pulse Mode --- */
.pulse {
  border-radius: 50%;
  border: 2px solid;
  background-color: rgba(0, 255, 0, 0.2);
  animation: pulse infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* --- Laser Mode (borde parpadeante) --- */
.laser-line {
  position: absolute;
  background: transparent;
}

.laser-line.top, .laser-line.bottom {
  height: 2px;
  width: 100%;
  animation: scan-horizontal infinite;
}

.laser-line.left, .laser-line.right {
  width: 2px;
  height: 100%;
  animation: scan-vertical infinite;
}

.laser-line.top {
  top: 0;
  left: 0;
}

.laser-line.right {
  top: 0;
  right: 0;
}

.laser-line.bottom {
  bottom: 0;
  left: 0;
}

.laser-line.left {
  top: 0;
  left: 0;
}

@keyframes scan-horizontal {
  0% { background: transparent; }
  50% { background: currentColor; }
  100% { background: transparent; }
}

@keyframes scan-vertical {
  0% { background: transparent; }
  50% { background: currentColor; }
  100% { background: transparent; }
}

/* --- Scanner Mode (línea que baja) --- */
.scanner-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: currentColor;
  animation: scan-down infinite;
}

.scanner {
  border: 2px solid currentColor; /* recuadro usando el color */
  background-color: transparent;
}
@keyframes scan-down {
  0% {
    top: 0%;
    opacity: 1;
  }
  50% {
    top: 90%;
    opacity: 0.5;
  }
  100% {
    top: 0%;
    opacity: 1;
  }
}
</style>

<script>
export default {
  name: 'FaceMarker',
  props: {
    size: {
      type: Number,
      default: 25
    },
    color: {
      type: String,
      default: '#00ff00'
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 255, 0, 0.2)'
    },
    animationSpeed: {
      type: Number,
      default: 2
    },
    mode: {
      type: String,
      default: 'pulse', // puede ser 'pulse', 'laser', 'scanner'
      validator: (value) => ['pulse', 'laser', 'scanner'].includes(value)
    }
  },
  computed: {
    markerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        borderColor: this.color,
        backgroundColor: this.mode === 'pulse' ? this.backgroundColor : 'transparent',
        animationDuration: this.mode === 'pulse' ? this.animationSpeed + 's' : undefined
      };
    },
    lineStyle() {
      return {
        color: this.color,
        animationDuration: this.animationSpeed + 's'
      };
    },
    scannerStyle() {
      return {
        color: this.color,
        animationDuration: this.animationSpeed + 's'
      };
    }
  }
}
</script>
<!-- 
	how user : 
	<FaceMarker
  mode="pulse"
  :size="40"
  color="#00ff00"
  backgroundColor="rgba(0,255,0,0.2)"
  :animationSpeed="1.5"
  :style="{ top: '100px', left: '100px' }"
>
  <img src="face-icon.png" width="20" />
</FaceMarker>


-------

<FaceMarker
  mode="scanner"
  :size="60"
  color="#ff0000"
  :animationSpeed="2.5"
  :style="{ top: '300px', left: '300px' }"
>
  <img src="scanner-icon.png" width="24" />
</FaceMarker>

-----------
<FaceMarker
  mode="scanner"
  :size="60"
  color="#ff0000"
  :animationSpeed="2.5"
  :style="{ top: '300px', left: '300px' }"
>
  <img src="scanner-icon.png" width="24" />
</FaceMarker>

 -->